import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import LongReadMoreContent from "./LongReadMoreContent";
import LazyImage from "../LazyImage/LazyImage";

const CardLongTwoColumn = ({
  imgSrc = "",
  imgAlt = "",
  title = "",
  excerpt = "",
  fullContent = "",
  type = "right",
  ctas = [],
  enableReadMore = true,
  scrollToTop = () => {}
}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [imageSize, setImageSize] = useState({
    width: "160px",
    height: "160px"
  });
  const [fontSize, setFontSize] = useState({ title: "20px", text: "16px" });

  // Update styles based on screen size
  const updateStyles = () => {
    if (window.innerWidth <= 768) {
      setImageSize({ width: "116px", height: "116px" });
      setFontSize({ title: "18px", text: "14px" });
      setIsMobile(true);
    } else {
      setImageSize({ width: "160px", height: "160px" });
      setFontSize({ title: "20px", text: "16px" });
      setIsMobile(false);
    }
  };

  // Update styles on resize
  useEffect(() => {
    updateStyles();
    window.addEventListener("resize", updateStyles);
    return () => window.removeEventListener("resize", updateStyles);
  }, []);

  const floatDirection =
    type === "image-right" ? "card__image--minor-right" : "card__image--minor-left";

  return (
    <div>
      <LazyImage
        src={imgSrc}
        alt={imgAlt}
        width={imageSize.width}
        height={imageSize.height}
        aspectRatio="4/3"
        className={`card__image--minor ${floatDirection}`}
        style={{
          borderRadius: "8px"
        }}
        shimmerProps={{
          style: {
            borderRadius: "8px"
          }
        }}
      />
      <div>
        <h1 className="card__title" style={{ fontSize: fontSize.title }}>
          {title}
        </h1>
        <div className="card__excerpt" style={{ fontSize: fontSize.text }}>
          {excerpt}
        </div>
        <LongReadMoreContent
          fullContent={fullContent}
          floatDirection={floatDirection}
          ctas={ctas}
          enableReadMore={enableReadMore}
          scrollToTop={scrollToTop}
        />
      </div>
    </div>
  );
};

CardLongTwoColumn.propTypes = {
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  title: PropTypes.string,
  excerpt: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  fullContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  type: PropTypes.string,
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      cta_label: PropTypes.string,
      cta_destination: PropTypes.string
    })
  ),
  enableReadMore: PropTypes.bool,
  scrollToTop: PropTypes.func
};

export default CardLongTwoColumn;
